export class RoleDto {
  id?: number;
  description: string;
  type: string;
  code: string;
  status: string;
}
